if (!customElements.get('product-related')) {
  class ProductRelated extends HTMLElement {
    static ACTIVE_CLASS = 'is-active';

    constructor() {
      super();

      this.toggleRef = this.toggle.bind(this);
    }

    toggle() {
      this.classList.toggle(ProductRelated.ACTIVE_CLASS);
    }

    connectedCallback() {
      this.addEventListener('click', this.toggleRef);
    }
  }

  customElements.define('product-related', ProductRelated);
}
